/** @jsx jsx */
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const CtaSection = ({ cta, description, title, variant }) => {
  return (
    <Box
      bg="backgroundBright"
      sx={{ overflow: 'hidden', position: 'relative' }}
    >
      <img
        src={`/images/backgrounds/cta-${variant}-xsmall.svg`}
        alt=""
        aria-hidden="true"
        sx={{
          display: [null, 'none'],
          height: '135px',
          pointerEvents: 'none',
          position: 'absolute',
          top: '-2px',
          left: '50%',
          right: '0',
          transform: 'translateX(-50%)',
          width: '415px',
        }}
      />
      <Container
        pt={['170px', 7, null, 9]}
        pb={[7, 8, null, 10]}
        sx={{
          minHeight: [null, null, null, '365px'],
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <img
          src={`/images/backgrounds/cta-${variant}-left.svg`}
          alt=""
          aria-hidden="true"
          sx={{
            bottom: ['16px', null, '24px', 'auto'],
            display: ['none', 'block'],
            height: 'auto',
            pointerEvents: 'none',
            position: 'absolute',
            left: ['-40px', null, '-24px', '32px'],
            top: [null, null, null, '50%'],
            transform: [null, null, null, 'translateY(-50%)'],
            width: ['150px', null, '180px', '246px'],
          }}
        />
        <img
          src={`/images/backgrounds/cta-${variant}-right.svg`}
          alt=""
          aria-hidden="true"
          sx={{
            display: ['none', 'block'],
            height: 'auto',
            pointerEvents: 'none',
            position: 'absolute',
            top: ['16px', null, '24px', '50%'],
            right: ['-40px', null, '-24px', '32px'],
            transform: [null, null, null, 'translateY(-50%)'],
            width: ['145px', null, '175px', '235px'],
          }}
        />
        <Grid columns={[1, 12]}>
          <Box
            sx={{
              gridColumn: [null, '3 / 11', null, '4 / 10'],
              position: 'relative',
              zIndex: '1',
            }}
          >
            <Heading as="h2" mb={2} variant="title2">
              {title}
            </Heading>
            {description && (
              <Box
                variant="text.body1"
                sx={{
                  '& p': { m: 0 },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
            {cta && <Box mt={[3, 4]}>{cta}</Box>}
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default CtaSection
